import { useCallback } from 'react'
import { Facet, Sorting } from '../../search-spring/types/types'
import Filter from './Filter'
import ReadyToShipFilter from './ReadyToShipFilter'
import { clearFilterParams } from '../helpers/clearFilters'

type Props = {
  searchQuery: string
  filters: Facet[]
  sorting: Sorting
  triggerSearch: () => void
  activeFilters: number
  totalResults: number
  emptyProduct: boolean
}

function SearchPageHeader({searchQuery, filters, sorting, triggerSearch, activeFilters, totalResults, emptyProduct}: Props) {
  const hasReadyToShipFilter = filters.some((filter) => filter.values && filter.values.find((label) => label.value == 'Ready to Ship'))

  const memoizedTriggerSearch = useCallback(() => {
    triggerSearch()
  }, [triggerSearch])

  const clearFiltersAndResetSearch = (): void => {
    clearFilterParams()
    const urlChangeEvent = new CustomEvent('urlChange', { detail: {} })
    window.dispatchEvent(urlChangeEvent)
  }

  return (
    <>
      {!emptyProduct &&
        <>
          <div className="px-MD pt-LG pb-SM md:py-DLG">
            <p className="uppercase font-calibre text-sm-c">{`${searchQuery ? 'search results for' : ''}`}</p>
            <h1 className="text-3xl capitalize font-bstSpyre md:text-6xl mt-XS md:mt-MD">
              {searchQuery ?
              <>
                {searchQuery}&nbsp;<sup className="text-xs md:text-sm top-[-1em] md:top-[-1.5em] left-[-.5em]">({totalResults})</sup>
              </>
              :
                null  
              }
            </h1>
          </div>
          <div className="flex items-center justify-between px-MD pt-SM pb-MD">
            <Filter filters={filters} sorting={sorting} triggerSearch={memoizedTriggerSearch} activeFilters={activeFilters} />
            {hasReadyToShipFilter && <ReadyToShipFilter />}
          </div>
        </> 
      }

      {emptyProduct && activeFilters == 0 &&
        <div className="text-center px-MD pt-LG pb-SM md:py-DLG">
          <p className="uppercase font-calibre text-sm-c text-subdued">No results found</p>
          <h2 className="text-3xl font-bstSpyre md:text-6xl mt-XS md:mt-MD">Sorry, there are no results for “{searchQuery || ''}”</h2>
        </div>
      }

      {emptyProduct && activeFilters > 0 &&
        <div className="text-center px-MD pt-LG pb-SM md:py-DLG">
          <p className="font-calibre text-base text-subdued">If you are not seeing any results, try removing some of your selected filters.</p>
          <button className="Button Button--secondary-dark mt-5" onClick={clearFiltersAndResetSearch}>Clear all filters</button>
        </div>
      }



    </>
  )
}

export default SearchPageHeader
